var map = {
	"./alfa copy.png": 264,
	"./alfa.png": 265,
	"./america.png": 266,
	"./borussia.png": 267,
	"./capital.png": 268,
	"./congresso-original.png": 269,
	"./congresso.png": 270,
	"./corinthians.png": 271,
	"./craque.png": 272,
	"./cruzeiro.png": 273,
	"./estrela.png": 274,
	"./fausto.png": 275,
	"./flamengo.png": 276,
	"./fluminense.png": 277,
	"./imperium.png": 278,
	"./metralhas.png": 279,
	"./river.png": 280,
	"./santos.png": 281,
	"./saopaulo.png": 282,
	"./semescudo.svg": 25,
	"./sobradinhense.png": 283,
	"./torteria.png": 284,
	"./vasco.png": 285,
	"./zecabol.png": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;